"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
require("./ExtendedPeoplePicker.scss");
var BaseExtendedPicker_1 = require("../BaseExtendedPicker");
/**
 * {@docCategory ExtendedPeoplePicker}
 */
var BaseExtendedPeoplePicker = /** @class */ (function (_super) {
    tslib_1.__extends(BaseExtendedPeoplePicker, _super);
    function BaseExtendedPeoplePicker() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return BaseExtendedPeoplePicker;
}(BaseExtendedPicker_1.BaseExtendedPicker));
exports.BaseExtendedPeoplePicker = BaseExtendedPeoplePicker;
/**
 * {@docCategory ExtendedPeoplePicker}
 */
var ExtendedPeoplePicker = /** @class */ (function (_super) {
    tslib_1.__extends(ExtendedPeoplePicker, _super);
    function ExtendedPeoplePicker() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ExtendedPeoplePicker;
}(BaseExtendedPeoplePicker));
exports.ExtendedPeoplePicker = ExtendedPeoplePicker;
//# sourceMappingURL=ExtendedPeoplePicker.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib-commonjs/components/ExtendedPicker/PeoplePicker/ExtendedPeoplePicker.js
// module id = 991
// module chunks = 0